export enum Role {
    Tank,
    Healer,
    MeleeDps,
    RangedDps,
}
